import MainLayout from "@/layouts/MainLayout";

const notifications = [
  {
    id: 1,
    title: "New patient registered",
    description: "John Doe has been registered as a new patient.",
    time: "10 minutes ago",
    read: false,
  },
  {
    id: 2,
    title: "Questionnaire completed",
    description: "Jane Smith has completed the initial health questionnaire.",
    time: "1 hour ago",
    read: false,
  },
  {
    id: 3,
    title: "Appointment scheduled",
    description:
      "An appointment has been scheduled for John Doe on December 2, 2025.",
    time: "2 hours ago",
    read: true,
  },
  {
    id: 4,
    title: "New message from Dr. Emily White",
    description: "Please review the latest test results for patient #5678.",
    time: "1 day ago",
    read: true,
  },
];

const NotificationsScreen = () => {
  return (
    <MainLayout>
      <div className="p-4 sm:p-6 md:p-8">
        <h1 className="text-2xl sm:text-3xl font-bold mb-4">Notifications</h1>
        <div className="bg-white rounded-lg shadow-md">
          <ul className="divide-y divide-gray-200">
            {notifications.map((notification) => (
              <li
                key={notification.id}
                className={`p-4 hover:bg-gray-50 ${
                  !notification.read ? "bg-blue-50" : ""
                }`}
              >
                <div className="flex items-start">
                  <div className="flex-1">
                    <p
                      className={`font-semibold ${
                        !notification.read ? "text-blue-800" : "text-gray-900"
                      }`}
                    >
                      {notification.title}
                    </p>
                    <p className="text-sm text-gray-600">
                      {notification.description}
                    </p>
                  </div>
                  <div className="text-xs text-gray-500 ml-4">
                    {notification.time}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MainLayout>
  );
};

export default NotificationsScreen;
